import { InjectionToken } from '@angular/core';
import { EnvMicroKlamIam } from '../config/env.micro.klam-iam';
import { EnvMicroOrganization } from '../config/env.micro.organization';
import { EnvMicroReport } from './env.micro.report';
import { EnvMicroPeople } from './env.micro.people';
import { EnvMicroMessaging } from './env.micro.messaging';
import { EnvMicroDocument } from './env.micro.document';
import { EnvMicroNotifications } from './env.micro.notifications';
import { EnvMicroMasterData } from './env.micro.master-data';
import { EnvMicroEmployee } from './env.micro.employee';
import { EnvMicroHr } from './env.micro.hr';
import { EnvMicroAgreement } from './env.micro.agreement';
import { EnvMicroPayroll } from './env.micro.payroll';
import { EnvMicroAccounting } from './env.micro.accounting';
import { EnvMicroTreasury } from './env.micro.treasury';
import { EnvMicroIntegration } from './env.micro.integration';
import { EnvMicroAudit } from './env.micro.audit';

export const KLAB_IAM_ENV = new InjectionToken<EnvMicroKlamIam>('KLAB_IAM_ENV');
export const ORG_ENV = new InjectionToken<EnvMicroOrganization>('ORG_ENV');
export const REPORT_ENV = new InjectionToken<EnvMicroReport>('REPORT_ENV');
export const PEOPLE_ENV = new InjectionToken<EnvMicroPeople>('PEOPLE_ENV');
export const MESSAGING_ENV = new InjectionToken<EnvMicroMessaging>('MESSAGING_ENV');
export const DOCUMENT_ENV = new InjectionToken<EnvMicroDocument>('DOCUMENT_ENV');
export const NOTIFICATIONS_ENV = new InjectionToken<EnvMicroNotifications>('NOTIFICATIONS_ENV');
export const MASTER_DATA_ENV = new InjectionToken<EnvMicroMasterData>('MASTER_DATA_ENV');
export const EMPLOYEE_ENV = new InjectionToken<EnvMicroEmployee>('EMPLOYEE_ENV');
export const HR_ENV = new InjectionToken<EnvMicroHr>('HR_ENV');
export const AGREEMENT_ENV = new InjectionToken<EnvMicroAgreement>('AGREEMENT_ENV');
export const PAYROLL_ENV = new InjectionToken<EnvMicroPayroll>('PAYROLL_ENV');
export const ACCOUNTING_ENV = new InjectionToken<EnvMicroAccounting>('ACCOUNTING_ENV');
export const TREASURY_ENV = new InjectionToken<EnvMicroTreasury>('TREASURY_ENV');
export const INTEGRATION_ENV = new InjectionToken<EnvMicroIntegration>('INTEGRATION_ENV');
export const AUDIT_ENV = new InjectionToken<EnvMicroAudit>('AUDIT_ENV');
